import EventBus from './main';

export default {
    darkMode: false,

    isDarkModeEnabled: () => {
        return this.darkMode;
    },

    setDarkModeEnabled: (enabled) => {
        if (typeof localStorage === undefined) {
            return;
        }

        this.darkMode = enabled;
        localStorage.setItem("darkTheme", this.darkMode);
    },

    loadTheme: () => {
        this.darkMode = (JSON.parse(localStorage.getItem("darkTheme")) || false);
        return this.darkMode;
    }
};



// WEBPACK FOOTER //
// ./src/theme.js